import Vue from 'vue'
import Vuex from 'vuex'

import Homepage from "@/components/Homepage";
import Gallery from "@/components/Gallery";
import Studio from "@/components/Studio";
import Router from 'vue-router'
import About from "@/components/About";
import Contact from "@/components/Contact";
import Preise from "@/components/Preise";
import Impressum from "@/components/Impressum";
import GalleryView from "@/components/GalleryView";


Vue.use(Router);
Vue.use(Vuex);

const router = new Router( {
  routes:[
    {
      path: '*',
      component: Homepage,
    },
    {
      path: '/gallery',
      component: Gallery,

    },
    
    {
      name: 'galleryview',
      path: '/gallery/:view',
      component: GalleryView,
      props: true,

    },
    {
      path: '/studio',
      component: Studio
    },
    {
      path: '/kontakt',
      component: Contact
    },
    {
      path: '/about',
      component: About
    },

    {
      path: '/preise',
      component: Preise
    },
    {
      path: '/impressum',
      component: Impressum
    }
  ]
});

export default router;